import { render } from "./TemplateEditPage2.vue?vue&type=template&id=41261461"
import script from "./TemplateEditPage2.vue?vue&type=script&lang=js"
export * from "./TemplateEditPage2.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__